module.exports = __webpack_public_path__ + "img/badge.69520cf6.png";